import * as S from './Disclaimer.styled';

export default function Disclaimer() {
    return (
        <S.DisclaimerContainer>
            <S.DisclaimerText>
                <span style={{ whiteSpace: 'nowrap' }}>For your convenience,</span>{' '}
                <span style={{ whiteSpace: 'nowrap' }}>we permit rescheduling of</span>{' '}
                <span style={{ whiteSpace: 'nowrap' }}>consultation calls</span>{' '}
                <span style={{ whiteSpace: 'nowrap' }}>(up to twice);</span> <br />
                additional changes may incur charges or require the support team's review.
            </S.DisclaimerText>
        </S.DisclaimerContainer>
    );
}
